import { userSignUp } from "../../../actions/loginActions";
import { addFacebookAccount, addGoogleReviewAccount, getFacebookDetails, googleUserDetails } from "./connectSocialAcc";
import { successLinkedinCallBack } from "./LinkedInCallback";

const authenticateUser = (response) => {
    if (response && Object.keys(response).length > 0) {
        const { type, code, dispatch, history, referePageLink, referenceId, themeId } = response;
        const signUpAction = (payload) => socialSignup({...payload, referenceId, themeId, referePageLink}, dispatch, history)

        if (type == "google") {
            addGoogleReviewAccount(code, ({token}) => getGoogleUserDetails(token, signUpAction));
        } else if (type == "facebook") {
            addFacebookAccount(code, 3, ({token}) => getFacebookUserDetails(token, signUpAction));
        } else if(response.type == "linkedin") {
            getLinkedinUserDetails(code, signUpAction); 
        } else if(response.type == "email"){
            const data = code.split('-');
            if(data?.length == 3){
                signUpAction({ fullName: atob(data[2]), emailId: atob(data[0]), password: atob(data[1]), provider: "signup", authId: "", picture: "" })
            }
        }
    }
}

const socialSignup = (data, dispatch, history) => {
    if (data && Object.keys(data).length > 0) {
        const { fullName, emailId, provider, authId, picture, password = "", referenceId, themeId, referePageLink } = data;
        const payload = {
            utm_campaign: "micro-tool",
            utm_source: "",
            password,
            fullName,
            emailId,
            picture,
            referePageLink,
            createFrom: provider,
            oauth_uid: authId,
            referenceId,
            themeId
        };
        dispatch(userSignUp(payload, history, () => {}, () => {}))
    }
}

const getGoogleUserDetails = (token, signUpAction) => {
    googleUserDetails(token).then(res =>{
        if(res && res.data){
            const { picture, name, email, sub } = res.data;
            signUpAction({picture, fullName: name, emailId: email, provider: "google", authId: sub })
        }
    }).catch(ex => console.log("google error --->", ex));
}

const getFacebookUserDetails = (token, signUpAction) => {
    getFacebookDetails({access_token: token}).then(res =>{
        if(res && res.data){
            const { name, email, id } = res.data;
            const picture = `https://graph.facebook.com/${id}/picture`;
            signUpAction({picture, fullName: name, emailId: email, provider: "facebook", authId: id });
        }
    }).catch(ex => console.log("facebook error --->", ex));
}

const getLinkedinUserDetails = (token, signUpAction) => {
    successLinkedinCallBack(token).then(res =>{
        if(res && res.data){
            const { responseData } = res.data;
            if(responseData && Object.keys(responseData).length > 0){
                const { picture, email, id, fname, lname } = responseData;
                const name = `${fname} ${lname}`;
                signUpAction({picture, fullName: name, emailId: email, provider: "linkedin", authId: id });
            }
        }
    }).catch(ex => console.log("linkedin error --->", ex));
}


export default authenticateUser;